module.exports = __webpack_public_path__ + "media/country_flags/cu-bd6b57e4.png";